import LoginForm from '../components/LoginForm'
import { useEffect, useState } from 'react'
import { ScreenMode, ScreenModeType } from '../pages/LoginRegisterPages'
import CookieManager from '../lib/CookiesManager'

interface LoginPageProps {
  onSwitchMode: (mode: ScreenModeType) => void
}

const LoginPage: React.FC<LoginPageProps> = ({ onSwitchMode }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsLoggedIn(!!CookieManager.getToken())

    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 0)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      className={`${
        isVisible ? 'opacity-100' : 'opacity-0'
      } transition-opacity duration-1000 ease-in-out  flex flex-col justify-center items-start h-screen w-full text-anthracite`}
    >
      <LoginForm />
    </div>
  )
}

export default LoginPage
